import { render, staticRenderFns } from "./RightSection.vue?vue&type=template&id=28a31798&scoped=true&"
import script from "./RightSection.vue?vue&type=script&lang=js&"
export * from "./RightSection.vue?vue&type=script&lang=js&"
import style0 from "./RightSection.vue?vue&type=style&index=0&id=28a31798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a31798",
  null
  
)

export default component.exports